import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SnapshotProvider } from "./contexts/SnapshotContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LangProvider } from "./contexts/LangContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CierreMes from "./pages/CierreMes";
import Ventajas from "./pages/Ventajas";
import Objetivos from "./pages/Objetivos";
import Consultoras from "./pages/Consultoras";
import Jerarquia from "./pages/Jerarquia";
import Historico from "./pages/Historico";
import Alertas from "./pages/Alertas";
import SubirCSV from "./pages/SubirCSV";
import Usuarios from "./pages/Usuarios";
import Perfil from "./pages/Perfil";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <SnapshotProvider>
              <Layout />
            </SnapshotProvider>
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/cierre-mes" element={<CierreMes />} />
        <Route path="/ventajas" element={<Ventajas />} />
        <Route path="/objetivos" element={<Objetivos />} />
        <Route path="/consultoras" element={<Consultoras />} />
        <Route path="/jerarquia" element={<Jerarquia />} />
        <Route path="/historico" element={<Historico />} />
        <Route path="/alertas" element={<Alertas />} />
        <Route path="/subir" element={<SubirCSV />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/perfil" element={<Perfil />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <AppRoutes />
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
